import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CDialog from "./CDialog";
import CButton from "./CButton";
import CTextField from "./CTextField";

const CommentDialog = ({
  open,
  onClose,
  onSubmit,
  title = "Comment",
  description,
  comment = "",
  onCommentChange,
  placeholder = "Enter your comment here",
  submitText = "Submit",
  cancelText = "Cancel",
  loading = false,
  rows = 4,
}) => {
  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <CDialog
      open={open}
      onClose={handleClose}
      className="bg-[#95AEBB80] !min-w-0 w-[calc(100vw-2rem)] sm:!min-w-[500px] sm:w-auto"
    >
      <div className="p-3">
        <p className="2xl:text-xl 2xl:leading-xl text-base leading-base text-grey-700 font-semibold mb-4 pr-[64px]">
          {title}
        </p>
        {description ? (
          <p className="text-sm text-gray-600 mb-3">{description}</p>
        ) : null}
        <CButton
          type="button"
          className="!h-auto !p-0 text-blue-500 font-semibold !ml-auto !underline absolute right-[16px] top-[16px]"
          onClick={handleClose}
          disabled={loading}
        >
          <CloseIcon className="text-gray-700" />
        </CButton>
        <CTextField
          name="comment"
          label=""
          placeholder={placeholder}
          value={comment}
          onChange={onCommentChange}
          multiline
          rows={rows}
          className="!p-0 w-full"
        />
        <div className="flex justify-center mt-8 gap-3">
          <CButton
            type="button"
            onClick={onSubmit}
            disabled={loading}
            className="bg-blue-500 hover:bg-blue-700 min-w-[80px] text-white border border-solid border-blue-500 hover:border-blue-700"
          >
            {loading ? "Submitting..." : submitText}
          </CButton>
          <CButton
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="bg-transparent hover:bg-blue-500 border border-solid border-blue-500 hover:border-blue-500 min-w-[80px] text-blue-500 hover:text-white"
          >
            {cancelText}
          </CButton>
        </div>
      </div>
    </CDialog>
  );
};

export default CommentDialog;
